// Generated by purs version 0.15.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as PartyCarlo_Capability_LogMessages from "../PartyCarlo.Capability.LogMessages/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
import * as PartyCarlo_Data_Log from "../PartyCarlo.Data.Log/index.js";
import * as PartyCarlo_Data_Probability from "../PartyCarlo.Data.Probability/index.js";
import * as PartyCarlo_Data_SortedArray from "../PartyCarlo.Data.SortedArray/index.js";
import * as PartyCarlo_Pages_Home_Error from "../PartyCarlo.Pages.Home.Error/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(PartyCarlo_Data_Probability.showProbability)));
var genericShowArgsArgument = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_DateTime.showDateTime);
var showTuple = /* #__PURE__ */ Data_Tuple.showTuple(Data_Show.showInt)(Data_Show.showInt);
var display = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Pages_Home_Error.displayError);
var display1 = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Data_Display.displayInt);
var display2 = /* #__PURE__ */ PartyCarlo_Data_Display.display(/* #__PURE__ */ PartyCarlo_Data_Display.displayArray(PartyCarlo_Data_Display.displayProbability));
var display3 = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Data_Display.displayMilliseconds);
var diff = /* #__PURE__ */ Data_DateTime.diff(Data_Time_Duration.durationMilliseconds);
var fold = /* #__PURE__ */ Data_Array.fold(Data_Monoid.monoidString);
var display4 = /* #__PURE__ */ PartyCarlo_Data_Display.display(/* #__PURE__ */ PartyCarlo_Data_Display.displayTuple(PartyCarlo_Data_Display.displayInt)(PartyCarlo_Data_Display.displayInt));
var DataState = /* #__PURE__ */ (function () {
    function DataState() {

    };
    DataState.value = new DataState();
    return DataState;
})();
var ResultsState = /* #__PURE__ */ (function () {
    function ResultsState() {

    };
    ResultsState.value = new ResultsState();
    return ResultsState;
})();
var LoadingState = /* #__PURE__ */ (function () {
    function LoadingState() {

    };
    LoadingState.value = new LoadingState();
    return LoadingState;
})();
var PartyCarloButtonPressed = /* #__PURE__ */ (function () {
    function PartyCarloButtonPressed(value0) {
        this.value0 = value0;
    };
    PartyCarloButtonPressed.create = function (value0) {
        return new PartyCarloButtonPressed(value0);
    };
    return PartyCarloButtonPressed;
})();
var Transition = /* #__PURE__ */ (function () {
    function Transition(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Transition.create = function (value0) {
        return function (value1) {
            return new Transition(value0, value1);
        };
    };
    return Transition;
})();
var RunAction = /* #__PURE__ */ (function () {
    function RunAction() {

    };
    RunAction.value = new RunAction();
    return RunAction;
})();
var ParsingFailed = /* #__PURE__ */ (function () {
    function ParsingFailed(value0) {
        this.value0 = value0;
    };
    ParsingFailed.create = function (value0) {
        return new ParsingFailed(value0);
    };
    return ParsingFailed;
})();
var ParsedNProbabilities = /* #__PURE__ */ (function () {
    function ParsedNProbabilities(value0) {
        this.value0 = value0;
    };
    ParsedNProbabilities.create = function (value0) {
        return new ParsedNProbabilities(value0);
    };
    return ParsedNProbabilities;
})();
var Distribution = /* #__PURE__ */ (function () {
    function Distribution(value0) {
        this.value0 = value0;
    };
    Distribution.create = function (value0) {
        return new Distribution(value0);
    };
    return Distribution;
})();
var RunningNExperiments = /* #__PURE__ */ (function () {
    function RunningNExperiments(value0) {
        this.value0 = value0;
    };
    RunningNExperiments.create = function (value0) {
        return new RunningNExperiments(value0);
    };
    return RunningNExperiments;
})();
var MonteCarloFailed = /* #__PURE__ */ (function () {
    function MonteCarloFailed() {

    };
    MonteCarloFailed.value = new MonteCarloFailed();
    return MonteCarloFailed;
})();
var CalculationDuration = /* #__PURE__ */ (function () {
    function CalculationDuration(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    CalculationDuration.create = function (value0) {
        return function (value1) {
            return new CalculationDuration(value0, value1);
        };
    };
    return CalculationDuration;
})();
var Intervals = /* #__PURE__ */ (function () {
    function Intervals(value0) {
        this.value0 = value0;
    };
    Intervals.create = function (value0) {
        return new Intervals(value0);
    };
    return Intervals;
})();
var logWith = function (dictLogMessages) {
    var composeKleisliFlipped = Control_Bind.composeKleisliFlipped((dictLogMessages.Monad0()).Bind1());
    var logMessage = PartyCarlo_Capability_LogMessages.logMessage(dictLogMessages);
    return function (dictNow) {
        var mkLog = PartyCarlo_Data_Log.mkLog(dictNow);
        return function (f) {
            return function (l) {
                return composeKleisliFlipped(logMessage)(mkLog(f(l)))(l);
            };
        };
    };
};
var logLevel = function (v) {
    if (v instanceof PartyCarloButtonPressed) {
        return PartyCarlo_Data_Log.Debug.value;
    };
    if (v instanceof Transition) {
        return PartyCarlo_Data_Log.Debug.value;
    };
    if (v instanceof RunAction) {
        return PartyCarlo_Data_Log.Debug.value;
    };
    if (v instanceof ParsingFailed) {
        return PartyCarlo_Data_Log.Info.value;
    };
    if (v instanceof ParsedNProbabilities) {
        return PartyCarlo_Data_Log.Info.value;
    };
    if (v instanceof Distribution) {
        return PartyCarlo_Data_Log.Debug.value;
    };
    if (v instanceof RunningNExperiments) {
        return PartyCarlo_Data_Log.Info.value;
    };
    if (v instanceof MonteCarloFailed) {
        return PartyCarlo_Data_Log["Error"].value;
    };
    if (v instanceof CalculationDuration) {
        return PartyCarlo_Data_Log.Info.value;
    };
    if (v instanceof Intervals) {
        return PartyCarlo_Data_Log.Debug.value;
    };
    throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 84, column 12 - line 94, column 39): " + [ v.constructor.name ]);
};
var log = function (dictLogMessages) {
    var logWith1 = logWith(dictLogMessages);
    return function (dictNow) {
        return logWith1(dictNow)(logLevel);
    };
};
var genericHomeStateType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return DataState.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ResultsState.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return LoadingState.value;
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 73, column 1 - line 73, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof DataState) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ResultsState) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LoadingState) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 73, column 1 - line 73, column 64): " + [ x.constructor.name ]);
    }
};
var showHomeStateType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericHomeStateType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "DataState";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "ResultsState";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "LoadingState";
        }
    }))))
};
var genericShowArgsArgument1 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showHomeStateType);
var genericHomeLog = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new PartyCarloButtonPressed(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Transition(x.value0.value0.value0, x.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return RunAction.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new ParsingFailed(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new ParsedNProbabilities(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new Distribution(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new RunningNExperiments(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return MonteCarloFailed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new CalculationDuration(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
            return new Intervals(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 32, column 1 - line 32, column 52): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PartyCarloButtonPressed) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Transition) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)));
        };
        if (x instanceof RunAction) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ParsingFailed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof ParsedNProbabilities) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof Distribution) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof RunningNExperiments) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof MonteCarloFailed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof CalculationDuration) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))))))));
        };
        if (x instanceof Intervals) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))));
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 32, column 1 - line 32, column 52): " + [ x.constructor.name ]);
    }
};
var showHomeLog = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericHomeLog)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument1)({
        reflectSymbol: function () {
            return "PartyCarloButtonPressed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument1)(genericShowArgsArgument1))({
        reflectSymbol: function () {
            return "Transition";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "RunAction";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(PartyCarlo_Pages_Home_Error.showError))({
        reflectSymbol: function () {
            return "ParsingFailed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "ParsedNProbabilities";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "Distribution";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "RunningNExperiments";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "MonteCarloFailed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument)(genericShowArgsArgument))({
        reflectSymbol: function () {
            return "CalculationDuration";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dist";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "p90";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "p95";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "p99";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
        reflectSymbol: function () {
            return "p999";
        }
    })(showTuple))(showTuple))(showTuple))(showTuple))(/* #__PURE__ */ PartyCarlo_Data_SortedArray.showSortedArray(Data_Show.showInt)))))({
        reflectSymbol: function () {
            return "Intervals";
        }
    })))))))))))
};
var displayHomeStateType = {
    display: function (v) {
        if (v instanceof DataState) {
            return "data";
        };
        if (v instanceof ResultsState) {
            return "results";
        };
        if (v instanceof LoadingState) {
            return "loading";
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 78, column 1 - line 81, column 37): " + [ v.constructor.name ]);
    }
};
var display5 = /* #__PURE__ */ PartyCarlo_Data_Display.display(displayHomeStateType);
var displayHomeLog = {
    display: function (v) {
        if (v instanceof PartyCarloButtonPressed) {
            return "party carlo pressed in " + (display5(v.value0) + " view.");
        };
        if (v instanceof Transition) {
            return "changing view from " + (display5(v.value0) + (" to " + (display5(v.value1) + ".")));
        };
        if (v instanceof RunAction) {
            return "run action initiated.";
        };
        if (v instanceof ParsingFailed) {
            return "parsing failed: " + display(v.value0);
        };
        if (v instanceof ParsedNProbabilities) {
            return "parsed probabilities for " + (display1(Data_Array.length(v.value0)) + " attendees.");
        };
        if (v instanceof Distribution) {
            return "parsed distribution: " + display2(v.value0);
        };
        if (v instanceof RunningNExperiments) {
            return "running " + (display1(v.value0) + " experiments.");
        };
        if (v instanceof MonteCarloFailed) {
            return "Monte Carlo confidence interval calculation failed.";
        };
        if (v instanceof CalculationDuration) {
            return "result calculated in " + (display3(diff(v.value1)(v.value0)) + ".");
        };
        if (v instanceof Intervals) {
            return fold([ "result set: p90=", display4(v.value0.p90), " p95=", display4(v.value0.p95), " p99=", display4(v.value0.p99), " p99.9=", display4(v.value0.p999) ]);
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Logs (line 37, column 1 - line 66, column 130): " + [ v.constructor.name ]);
    }
};
export {
    PartyCarloButtonPressed,
    Transition,
    RunAction,
    ParsingFailed,
    ParsedNProbabilities,
    Distribution,
    RunningNExperiments,
    MonteCarloFailed,
    CalculationDuration,
    Intervals,
    DataState,
    ResultsState,
    LoadingState,
    logLevel,
    logWith,
    log,
    genericHomeLog,
    showHomeLog,
    displayHomeLog,
    genericHomeStateType,
    showHomeStateType,
    displayHomeStateType
};
